import { jsx as _jsx } from "react/jsx-runtime";
import classes from './Settings.module.scss';
import { SettingsIcon } from '@icons';
import { useTypedDispatch } from '@hooks/useTypedDispatch';
import { triggerMetricsEvent } from '@metrics';
import Button from '@components/shared/Button/Button';
import { useSelector } from 'react-redux';
import { childUserSelector } from '@store/models/user/selectors';
import { useNavigate } from 'react-router';
import { Page } from '@const';
const Settings = () => {
    const isChildUser = useSelector(childUserSelector);
    const navigate = useNavigate();
    const { dialogModel: { openDialog }, } = useTypedDispatch();
    const handleSettingsClick = () => {
        isChildUser ? openDialog('subscribeSettings') : navigate(Page.ParentSettings);
        triggerMetricsEvent({ element: 'settingsButton' });
    };
    return (_jsx(Button, { className: classes.button, text: "", size: "sm", variant: "transparent", icon: _jsx(SettingsIcon, { containerClasses: classes.icon }), full: true, onClick: handleSettingsClick }));
};
export default Settings;
